module.exports = __webpack_public_path__ + "welcome_logo.svg?361f0971f778b35d6484e3320069c5b5";